/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".auth-box-w[_ngcontent-%COMP%]{padding-bottom:30px}.logo-w[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.buttons-w[_ngcontent-%COMP%], .form-group[_ngcontent-%COMP%]{text-align:left}"];
export { styles as styles };
